import {useEffect, useState} from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import {collection, doc, getDoc, getDocs, increment, query, setDoc, updateDoc, where,} from "firebase/firestore";
import {firebaseConstants, getDb} from "../../../util/Constants";
import {useHistory, useParams} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Swal from "sweetalert2";
import {sendInviteEmail} from "../../../util/UploadUsers";
import _ from "lodash";

const bcrypt = require("bcryptjs");
const salt = bcrypt.genSaltSync(10);

export default function AddUser(props) {
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [userData, setUserData] = useState({});
  const [metadata, setMetadata] = useState({});
  const [loading, setLoading] = useState("data");
  const [startDate, setStartDate] = useState(new Date());
  const [isChecked, setIsChecked] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [regions, setRegions] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [registrationFeilds, setRegistrationFeilds] = useState([]);

  const history = useHistory();
  const { eventId } = useParams();

  const db = getDb();
  const utilRef = collection(db, firebaseConstants.dbUtil);
  const usersRef = collection(db, firebaseConstants.dbUsers);

  useEffect(() => {
    getMetaData().then((_data) => {
      console.log(_data);
      setMetadata(_data);

      getEventData().then((data) => {
        console.log(data);
        setRegistrationFeilds(data.registrationFeilds);
        if (props.signedInUser.projectType === "progress") {
          setDepartments(data.departments.length > 0 ? data.departments : []);
          setRegions(data.regions.length > 0 ? data.regions : []);
          setUserData({
            ...userData,
            department: data.departments[0],
            region: data.regions[0],
          });
        }
      });

      setLoading(null);
    });
  }, []);
  useEffect(async () => {
    const docRef = doc(db, "admins", props?.signedInUser?.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setUsersCount(docSnap.data().usersCount);
    } else {
    }
  }, []);

  const getEventData = async () => {
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        registrationFeilds: data.registrationFields,
        departments: data.departments,
        regions: data.region,
      };
    }
  };

  const getMetaData = async () => {
    let data = {};
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      data = docSnap.data();
    }
    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading("saving");
    try {
      let expiryDate = null;
      if (isChecked) {
        if (moment()._d < userData.expiryDate) {
          expiryDate = moment(userData.expiryDate).valueOf();
        } else {
          alert("timestamp not set or is before tomorrow");
          throw "timestamp not set or is before tomorrow";
        }
      } else {
        expiryDate = null;
      }

      if (usersCount < props.signedInUser?.maxUsers) {
        const userId = props.signedInUser.uid;
        const emailExistsQuery = query(
          collection(db, "users"),
          where("email_insensitive", "==", userData.email.toLowerCase()),
          where("eventId", "==", eventId)
        );
        const emailExistsSnapshot = await getDocs(emailExistsQuery);

        if (!emailExistsSnapshot.empty) {
          setLoading(null);
          return Swal.fire({
            icon: "error",
            title: "Email already exists",
            text: "The provided email is already registered.",
          });
        }
        await setDoc(doc(db, "users", userData.email + eventId), {
          eventId: eventId,
          achievementCount: 0,
          achievements: {
            highAchiever: 0,
            mostlyRight: 0,
            speedDemon: 0,
            streakOf10: 0,
          },
          attempts: 1,
          avatar: -1,
          capabilities: {}, // populate
          completed: false,
          completedOnce: false,
          currentLevel: 1,
          currentScore: 0,
          cognitiveScore: 0,
          aptitudeScore: 0,
          behaviourScore: 0,
          department:
            props.signedInUser.projectType === "progress" &&
            registrationFeilds.includes("department")
              ? userData.department
              : "",
          email: userData.email,
          email_insensitive: userData.email.toLowerCase(),
          isActive: true,
          canExpire: isChecked,
          lastCompletedScore: 0,
          lastUpdated: Date.now(),
          levelScores: {},
          levels: {},
          name: userData.name,
          name_insensitive: userData.name.toLowerCase(),
          region:
            props.signedInUser.projectType === "progress" &&
            registrationFeilds.includes("region")
              ? userData.region
              : "",
          userCreated: Date.now(),
          expiryDate: expiryDate,
          userInfo: {email: userData.email, email_insensitive: userData.email.toLowerCase()}
        });
        await updateDoc(doc(db, "users", "analytics"), {
          [eventId]: increment(1),
        });
        await updateDoc(doc(getDb(), "admins", userId), {
          usersCount: increment(1),
        });

        await sendInviteEmail(userData.email, eventId); // sending invite email

        Swal.fire({
          icon: "success",
          title: "Invite Sent!",
          text: "Invitation has been sent to the candidate.",
        });
        history.push(`/admin/users/${eventId}`);

        // props.signedInUser.role==="admin"?:`/admin/users/new/${localStorage.getItem("eventId")}?superAdmin=gvb1hjj23n`}
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "You have reached your maximum users limit. Please upgrade your plan to add more users.",
        });
        history.push(`/admin/users/${eventId}`);
      }
    } catch (e) {
      console.log(e);
      setLoading(null);
    }
  };



  return (
    <>
      <Container fluid>
        <Row className="mb-4">
          <Col>
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">Add User</h2>
              </CardHeader>
              <CardBody>
                {loading !== "data" ? (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-2 justify-content-center">
                      <Col lg={8}>
                        <Row>
                          <Col lg={6}>
                            <FormGroup>
                              <Label for="name">Name</Label>
                              <Input
                                type="text"
                                name="name"
                                id="name"
                                value={userData.name}
                                className="form-control-alternative"
                                required
                                onChange={(e) => {
                                  setUserData({
                                    ...userData,
                                    name: e.target.value,
                                    name_insensitive:
                                      e.target.value.toLowerCase(),
                                  });
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg={6}>
                            <FormGroup>
                              <Label for="email">Email</Label>
                              <Input
                                type="email"
                                name="email"
                                id="email"
                                value={userData.email}
                                className="form-control-alternative"
                                required
                                onChange={(e) => {
                                  setUserData({
                                    ...userData,
                                    email: e.target.value,
                                    email_insensitive:
                                      e.target.value.toLowerCase(),
                                  });
                                }}
                                maxLength="40"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col>
                          {/* <Col lg={6}>
                            <FormGroup>
                              <Label for="name">Password</Label>
                              <Input
                                type="password"
                                name="passowrd"
                                id="password"
                                value={userData.password}
                                className="form-control-alternative"
                                required
                                onChange={(e) => {
                                  setUserData({
                                    ...userData,
                                    password: e.target.value,
                                    // name_insensitive: e.target.value.toLowerCase()
                                  });
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col> */}
                          {/* <Col lg={6}>
                            <FormGroup>
                              <Label for="name">Confirm Password</Label>
                              <Input
                                type="password"
                                name="passowrd"
                                id="password"
                                //value={userData.password}
                                className="form-control-alternative"
                                required
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col> */}

                          {props.signedInUser.projectType === "progress" && (
                            <>
                              {registrationFeilds.includes("department") && (
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="type">Department</Label>
                                    <Input
                                      type="select"
                                      name="department"
                                      id="department"
                                      value={userData.department}
                                      className="form-control-alternative"
                                      required
                                      onChange={(e) => {
                                        setUserData({
                                          ...userData,
                                          department: e.target.value,
                                        });
                                      }}
                                    >
                                      {departments &&
                                        departments.map((_department) => (
                                          <option
                                            value={_department}
                                            key={_department}
                                          >
                                            {_.startCase(
                                              _department
                                            )}
                                          </option>
                                        ))}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              )}
                              {registrationFeilds.includes("region") && (
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="type">Region</Label>
                                    <Input
                                      type="select"
                                      name="region"
                                      id="region"
                                      value={userData.region}
                                      className="form-control-alternative"
                                      required
                                      onChange={(e) => {
                                        setUserData({
                                          ...userData,
                                          region: e.target.value,
                                        });
                                      }}
                                    >
                                      {regions &&
                                        regions.map((_region) => (
                                          <option
                                            value={_region}
                                            key={_region}
                                          >
                                            {_.startCase(_region)}
                                          </option>
                                        ))}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              )}
                            </>
                          )}
                          <Col lg={12}>
                            <div className="ml-4">
                              <Input
                                onChange={(e) => {
                                  setIsChecked(e.target.checked);
                                  if (!e.target.checked) {
                                    setUserData({
                                      ...userData,
                                      expiryDate: null,
                                    });
                                  }
                                }}
                                type="checkbox"
                              />
                              <Label check>Can expire?</Label>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <FormGroup>
                              <DatePicker
                                disabled={!isChecked}
                                selected={startDate}
                                onChange={(date) => {
                                  setStartDate(date);
                                  setUserData({
                                    ...userData,
                                    expiryDate: date,
                                  });
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="text-right">
                            <Button
                              color="danger"
                              onClick={() => history.goBack()}
                              disabled={loading === "saving"}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="primary"
                              type="submit"
                              disabled={loading === "saving"}
                            >
                              {loading === "saving" ? (
                                <Spinner color="light" size="sm" />
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                ) : (
                  <div className="text-center py-5 mt-5">
                    <Spinner color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
